import React from 'react'
import styled from 'styled-components'
import { Navigate } from 'react-router-dom'
import LayiFrame, { layiPalette } from './ChatbotWidget/LayiFrame'
import { ROUTES } from '../constants'
import { localizedRoute } from '../utils'

// The full-page LAYI chat (`/chat`): the TopBar and, below it, the embedded Chainlit UI. Home page
// for ROLE_HOME_LAYI holders (see selectors/home.js); reachable by anyone who may use LAYI. Without
// that access the page sends the user to the viewer, the same way a deactivated dashboard does.
//
// Fixed to the viewport under the 60px sticky TopBar: the frame fills the rest whatever the root
// element's own height is.

const Page = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${layiPalette.surface};
`

export default function LayiPage({ canUseLayi, locale, t }) {
  if (!canUseLayi) return <Navigate to={localizedRoute(locale, ROUTES.LAYERS_ROUTE)} replace />

  return (
    <Page id="layi-page">
      <LayiFrame locale={locale} t={t} />
    </Page>
  )
}
